<template>
  <div class="container-fluid">
    <div class="row" v-if="modal">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="heading-color text-center p-5">{{modal.name}}</h1>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-md-12">
            <a class="sub-heading d-flex justify-content-center">
              <div class="singel-product single-product-download">
                <img class="img-fluid" :src="modal.thumbnailUrl" alt="">
              </div>
            </a>
          </div>
        </div>
        <!-- download section -->
        <div class="row justify-content-center">
          <DownloadIcon v-if="modal.PSD && modal.PSD !== 'null'" :format="`PSD`" :link="modal.PSD"></DownloadIcon>
          <DownloadIcon v-if="modal.PNG &&  modal.PNG !== 'null'" :format="`PNG`" :link="modal.PNG"></DownloadIcon>
          <DownloadIcon v-if="modal.JPG &&  modal.JPG !== 'null'" :format="`JPG`" :link="modal.JPG"></DownloadIcon>
          <DownloadIcon v-if="modal.AI &&  modal.AI !== 'null'" :format="`AI`" :link="modal.AI"></DownloadIcon>
          <DownloadIcon v-if="modal.EPS &&  modal.EPS !== 'null'" :format="`EPS`" :link="modal.EPS"></DownloadIcon>
          <DownloadIcon v-if="modal.PDF &&  modal.PDF !== 'null'" :format="`PDF`" :link="modal.PDF"></DownloadIcon>
          <DownloadIcon v-if="modal.powerpoint &&  modal.powerpoint !== 'null'" :format="`powerpoint`" :link="modal.powerpoint"></DownloadIcon>
          <DownloadIcon v-if="modal.XLS &&  modal.XLS !== 'null'" :format="`XLS`" :link="modal.XLS"></DownloadIcon>
          <DownloadIcon v-if="modal.WORD_DOC &&  modal.WORD_DOC !== 'null'" :format="`WORD_DOC`" :link="modal.WORD_DOC"></DownloadIcon>
          <DownloadIcon v-if="modal.MP4 &&  modal.MP4 !== 'null'" :format="`MP4`" :link="modal.MP4"></DownloadIcon>
        </div>
          <!-- button -->
        <div class="row d-flex justify-content-center" v-if="this.$route.params.type !== 'video'">
          <div class="col-xl-4 col-lg-5 col-md-5 col-8">
            <a @click="insertDownload(downloadLink('ALL'))" v-if="modal.ALL &&  modal.ALL !== 'null'" download class="download-all">
              <button class="format-btn btn">
                  Download All Formats
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import Branding from '@/models/Branding'
import Image from '@/models/Image'
import Presentation from '@/models/Presentation'
import DownloadIcon from '@/components/DownloadIcon'
export default{
  name: 'Download',
  components: {
    DownloadIcon
  },
  data () {
    return {
      modal: null
    }
  },
  mounted () {
    this.fetchDownload()
  },
  methods: {
    downloadLink (format) {
      return process.env.API_URL + '/download/' + this.$route.params.type + '/' +
              this.$route.params.id + '/' + format + '/file'
    },
    fetchDownload () {
      this.$store.dispatch('fetchDownload', { id: this.$route.params.id, type: this.$route.params.type })
        .then((result) => {
          this.modal = result.data.modal
          // this.initModal(result.data.modal)
          document.title = 'Img-Lib - ' + this.modal.name
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    initModal (res) {
      if (this.$route.params.type === 'branding') {
        this.modal = new Branding(res)
      } else if (this.$route.params.type === 'image') {
        this.modal = new Image(res)
      } else if (this.$route.params.type === 'presentation') {
        this.modal = new Presentation(res)
      }
    },
    insertDownload (redirectLink) {
      this.$store.dispatch('insertDownload', { id: this.$route.params.id, type: this.$route.params.type })
        .then((result) => {
          window.location.href = redirectLink
        })
        .catch((err) => this.$helper.catchHandler(err))
    }

  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Download.vue